import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shouldAutoAdvanceWhenLabelsComplete: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.shouldAutoAdvanceWhenLabelsComplete`,
    defaultMessage:
      'Automatically move applicant to next stage when all labels are completed',
  },
  goEnabled: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.goEnabled`,
    defaultMessage: 'Show stage in Hire Go',
  },
  allowRejectInHireGo: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.allowRejectInHireGo`,
    defaultMessage: 'Allow "Reject" from Hire Go',
  },
  asksHiringGoal: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.asksHiringGoal`,
    defaultMessage: 'Ask for the hiring goal in Hire Go',
  },
  asksHiringGoalDescription: {
    id: `app.containers.WorkflowEditor.components.StageDetail.settingsSwitches.messages.asksHiringGoalDescription`,
    defaultMessage:
      "A Hiring Manager who moves an applicant off this stage in Hire Go chooses the hiring goal the hire counts toward. With this on for any stage, a hire on this workflow must name a goal. Applicants already past this stage when it's turned on are exempt. Hire picks their goal, and it stays editable on the applicant's profile.",
  },
});
